/** @file HTTP_STATUS_CODES: the error code of a non-2xx reply that carries no error envelope. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { ErrorCode } from '@zilo/pose3d-format/errors/codes';

/**
 * Status → code for replies without an `ErrorBody` (a proxy page, an expired file URL); the inverse of the server's
 * `statusOf` where it is one-to-one. Any other status is `TRANSPORT` (R6).
 */
export const HTTP_STATUS_CODES: Readonly<Partial<Record<number, ErrorCode>>> = {
  401: ERROR_CODES.AUTH,
  403: ERROR_CODES.FORBIDDEN,
  404: ERROR_CODES.NOT_FOUND,
  409: ERROR_CODES.CONFLICT,
  413: ERROR_CODES.LIMIT,
  429: ERROR_CODES.RATE_LIMITED,
};
